import {
  SectionCompletionDetail,
  SectionStatus,
} from '@/api/manualCalculation/types';

import { FacTabKey } from '../Factors';
import { InfTabKey } from '../Inference/types';

export const getTabStatus = (
  tab: InfTabKey | FacTabKey,
  sectionsStatus: Record<string, SectionCompletionDetail> | undefined
): SectionStatus => {
  return sectionsStatus?.[tab]?.status ?? 'pending';
};
